<template>
  <section class="commentBox">

    <img class="commentBox-avatar" :src="comment.pic || avatarHolder" alt="avatar"/>

    <div class="commentBox-header">
      <span>
        {{ comment.userName || '' }}
        <em v-if="comment.topTag" class="commentBox-header-top">置顶</em>
        <b v-if="comment.role" class="commentBox-header-teacher"><em>{{ comment.role || '-' }}</em></b>
      </span>
      <i>{{ comment.restimeStr || '' }}</i>
    </div>

    <p class="commentBox-content">{{ comment.restext || '' }}</p>

    <div class="commentBox-reply" v-if="replyList.length">
      <div
        class="commentBox-reply-item"
        v-for="(item, index) in replyList"
        :key="index">
        <!-- @click="$emit('reply', { item: comment, subItem: item })"> -->
        <div v-if="!item.spreadTrigger" class="commentBox-reply-item-wrapper">
          <dl>
            <dt>
              <span>{{ `${item.userName} ` }}</span> <span>回复</span> <span>{{ ` ${item.replyName}` }}</span>
              <!-- <em class="floorTag">{{!spread && (index === replyList.length - 1) ? loft : index + 1}}</em> -->
            </dt>
            <dd :class="{tail: index === replyList.length - 1}">{{item.restext}}</dd>
          </dl>
        </div>

        <button v-if="item.spreadTrigger" @click="showAll">
          展开隐藏楼层
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import avatarHolder from './.default/avatar.png'
import timeFormatComment from '../../filters/format-time-comment'

export default {
  props: {
    comment: {
      type: Object,
      default: () => {
        return {
          replyList: [{}, {}, {}]
        }
      }
    }
  },

  filters: {
    timeFormatComment
  },

  data () {
    return {
      avatarHolder: avatarHolder,
      spread: false
    }
  },

  computed: {
    replyList () {
      if (!this.comment.replyList) {
        return []
      }
      if (this.comment.replyList.length <= 3) {
        return this.comment.replyList
      }
      if (this.spread) {
        return this.comment.replyList
      }
      return this.comment.replyList
        .slice(0, 2)
        .concat([{spreadTrigger: true}])
        .concat(this.comment.replyList.slice(-1))
    },
    loft () {
      return this.comment.replyList.length
    }
  },

  methods: {
    showAll () {
      this.spread = true
    }
  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../../style/main";

$global-width: 750;

.commentBox {
  width: rem(690);
  background-color: #fff;
  position: relative;
  margin-bottom: rem(27);
  &-avatar {
    position: absolute;
    top: rem(10);
    height: rem(70);
    width: rem(70);
    border-radius: rem(10);
    margin-right: rem(20);
  }
  &-teacherTag {
    float: left;
    height: rem(50);
    width: rem(58);
    line-height: rem(50);

    em {
      display: inline-block;
      height: rem(30);
      width: rem(58);
      color: #fff;
      font-size: rem(22);
      line-height: rem(30);
      text-align: center;
      background-color: #F48F00;
    }
  }

  &-header {
    height: rem(50);
    width: rem(592);
    padding-left: rem(99);
    img {
      float: left;
      height: rem(70);
      width: rem(70);
      border-radius: rem(10);
      margin-right: rem(20);
    }

    span {
      /*float: left;*/
      height: rem(50);
      color: #CE9253;
      font-size: rem(24);
      line-height: rem(50);
      margin-right: rem(10);
    }

    i {
      float: right;
      height: rem(50);
      color: #B5B5B5;
      font-size: rem(22);
      line-height: rem(50);
    }

    &-top,
    &-teacher {
      display: inline-block;
      height: rem(32);
      width: rem(64);
      color: #F48F00;
      font-size: rem(22);
      text-align: center;
      line-height: rem(32);
      border: 1px solid #FFD08E;
      background-color: #FFF7E8;
      box-sizing: border-box;
      margin-right: rem(15);
      border-radius: rem(5);
    }

    &-teacher {
      background-color: transparent;
    }
  }

  &-content {
    width: 100%;
    margin-bottom: rem(15);
    padding-left: rem(99);
    box-sizing: border-box;
    color: #333;
    font-size: rem(28);
    line-height: rem(44);
    word-break: break-all;
  }

  &-reply {
    width: 100%;
    padding-left: rem(99);
    box-sizing: border-box;

    button {
      padding: rem(30) 0;
      width: 100%;
      color: #F48F00;
      font-size: rem(28);
      text-align: center;
      background-color: #F8F8F8;
      border: none;
      outline: none;

      &::after {
        content: '';
        display: block;
        height: rem(2);
        width: rem(570);
        margin: rem(30) auto 0;
        background-color: #DADADA;
      }
    }

    dl {
      background-color: #F8F8F8;
      padding-top: rem(30);
      padding-left: rem(25);

      dt {
        color: #999;
        font-size: rem(24);
        margin-bottom: rem(26);

        .floorTag {
          float: right;
          color: #B0B0B0;
          line-height: rem(24);
          text-indent: rem(10);
          letter-spacing: rem(10);
          background-color: #E8E8E8;
        }
      }

      dd {
        width: rem(570);
        color: #444;
        font-size: rem(28);
        line-height: rem(40);
        padding-bottom: rem(30);
        border-bottom: rem(2) solid #DADADA;

        &.tail {
          border: none;
        }
      }
    }
  }
}

</style>
